const IMG = "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=900&q=70&auto=format&fit=crop";

export const LivedIt = () => {
  return (
    <section className="relative py-20 sm:py-24 md:py-36 overflow-hidden btr-bg-glow" data-testid="lived-it-section">
      <div className="btr-beam btr-beam-drift" style={{ width: 480, height: 480, top: "10%", left: "-10%", background: "#a2020b", opacity: 0.18 }} />
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <div className="btr-reveal">
          <span className="btr-badge">
            <span className="dot" />
            More Than a Consultant
          </span>
          <h2 className="font-display font-extrabold text-white text-3xl sm:text-5xl lg:text-[3.25rem] mt-6 leading-[1.05] tracking-tight">
            More than a consultant — a property owner who has <span className="text-[#a2020b]">lived it</span>.
          </h2>
          <p className="font-body text-zinc-400 text-base sm:text-lg mt-6 leading-relaxed">
            What separates Before The Risk is perspective that cannot be taught. The founder is not only an
            industry professional — she is also an active commercial property owner who has personally
            navigated the claims process from the other side of the table.
          </p>
          <p className="font-body text-zinc-400 text-base sm:text-lg mt-5 leading-relaxed">
            That experience brings urgency, empathy, and precision to every report and every client relationship.
          </p>

          <div className="mt-9 flex items-center gap-3">
            <div className="h-[1px] w-12 bg-[#a2020b]" />
            <span className="font-display text-[11px] tracking-[0.3em] uppercase text-zinc-500">
              Professional • Owner • Advocate
            </span>
          </div>
        </div>

        <div className="btr-reveal relative">
          <div className="relative aspect-[5/6] max-w-md mx-auto lg:ml-auto rounded-xl overflow-hidden group">
            <img src={IMG} alt="Luxury commercial property" loading="lazy" decoding="async" width="900" height="1080" className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-[1.05]" />
            <div className="absolute inset-0 bg-gradient-to-tr from-[#050505] via-[#050505]/40 to-transparent" />
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_30%,rgba(162,2,11,0.35),transparent_60%)]" />
            <div className="absolute inset-0 btr-blueprint-overlay opacity-25" />
            <div className="absolute bottom-0 left-0 right-0 p-7">
              <div className="btr-glass rounded-md p-4 border-[#a2020b]/25">
                <div className="font-display text-white text-sm font-bold">Active Commercial Owner</div>
                <div className="font-body text-zinc-300 text-xs mt-1">
                  Lived experience on both sides of the claims process.
                </div>
              </div>
            </div>
            <div className="absolute top-0 right-0 h-full w-[3px] bg-gradient-to-b from-transparent via-[#a2020b] to-transparent" />
            <div className="absolute top-3 left-3 w-10 h-10 border-t-2 border-l-2 border-[#a2020b]/70" />
          </div>
        </div>
      </div>
    </section>
  );
};
